<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :UseScrollable="false"
        :HideModalFun="onHidden"
        :TitleWindow="title"
        :width="'40%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('insuranceSetup.Send'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
    >
        <b-row>
            <b-col md="12">
                <MdSelect
                    ref="option2"
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="notifyTemplateList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'recID'"
                    v-bind:ModelArray="valueTemplate"
                    v-bind:Multiple="false"
                    v-bind:AllowEmpty="false"
                    :Input="changeDropDownOption"
                    :CustomLabel="customLabelMessageType"
                    v-bind:isRequired="true"
                    v-bind:isValid="this.isMessageTypeValid"
                />
            </b-col>
        </b-row>
        <b-row v-bind:style="{ overflowY: body ? 'scroll' : '', height: body ? 'calc(40vh)' : '' }">
            <b-col lg="12" md="12" sm="12">
                <p v-html="body"></p>
            </b-col>
        </b-row>
    </BaseModal>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import MessageTemplateSetupsService from '@/services/messagetemplatesetups.service';
import PatientPortalsService from '@/services/patientportals.service';

export default {
    name: 'PatientPortalNotify',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        patientCodeList: {
            type: Array,
            default: () => []
        },
        notifyType: {
            type: String,
            required: true
        },
        notifyTemplateList: {
            Type: Array,
            default: () => []
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        }
    },
    data() {
        return {
            modalId: 'PatientPortalNotifyModal',
            emitCloseEvent: false,
            valueTemplate: null,
            isMessageTypeValid: true,
            subject: null,
            body: null
        };
    },
    computed: {
        title() {
            return this.notifyType === 'email'
                ? this.$t('Shared.EmailPatient')
                : this.$t('Shared.TextPatient');
        }
    },
    methods: {
        customLabelMessageType({ description }) {
            return `${description}`;
        },

        changeDropDownOption(item) {
            this.valueTemplate = item;
            this.subject = null;
            this.body = null;

            if (this.patientCodeList && this.patientCodeList.length === 1) {
                this.createNotificationMessage();
            }
        },

        resetData() {
            this.valueTemplate = null;
            this.subject = null;
            this.body = null;
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();

            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate_required()) {
                this.sendNotificationMessage();
            } else {
                bvModalEvent.preventDefault();

                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate_required() {
            this.isMessageTypeValid = this.valueTemplate ? true : false;
            return this.isMessageTypeValid;
        },

        async createNotificationMessage() {
            const params = {
                MessageType: this.valueTemplate.messageType,
                NotificationType: this.valueTemplate.notificationType,
                EntityCode: this.patientCodeList[0]
            };

            await MessageTemplateSetupsService.CreateNotificationMessage(params)
                .then(response => {
                    if (response.status == '200') {
                        this.body = response.data.body;
                        this.subject = response.data.subject;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async sendNotificationMessage() {
            let params = {
                messageType: this.valueTemplate.messageType,
                notificationType: this.valueTemplate.notificationType.toUpperCase(),
                patientCodeList: this.patientCodeList
            };

            await PatientPortalsService.sendNotificationMessage(params)
                .then(response => {
                    if (response.status == '200') {
                        if (response.data.success) {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('scheduleNotify.msgSent')
                            );
                            this.$emit('update:visible', false);
                            this.resetData();
                        } else {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                response.data.errorMessage,
                                'error'
                            );
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    }
};
</script>
